import React from 'react';

function TeachersEditor({ pageContent, uploading, uploadingField, addTableRow, deleteTableRow, updateTableRow, handleRowImageUpload }) {
  return (
    <div className="page-editor">
      <div className="editor-card">
        <h3>👨‍🏫 Teachers</h3>
        {(pageContent.teachers || []).map((t) => (
          <div key={t.id} style={{border:'1px solid #e2e8f0',padding:12,marginBottom:10}}>
            <input placeholder="Name" value={t.name || ''} onChange={(e) => updateTableRow('teachers', t.id, 'name', e.target.value)} className="form-input" />
            <input placeholder="Position" value={t.position || ''} onChange={(e) => updateTableRow('teachers', t.id, 'position', e.target.value)} className="form-input" />
            <input placeholder="Subject" value={t.subject || ''} onChange={(e) => updateTableRow('teachers', t.id, 'subject', e.target.value)} className="form-input" />
            {t.photo && <img src={t.photo} className="preview-img-sm" />}
            <label className="upload-label">{uploading && uploadingField === `teachers_${t.id}_photo` ? '⏳...' : '📷 Photo'}<input type="file" accept="image/*" style={{display:'none'}} onChange={(e) => { if (e.target.files[0]) handleRowImageUpload('teachers', t.id, 'photo', e.target.files[0]); }} /></label>
            <button className="remove-btn" onClick={() => deleteTableRow('teachers', t.id)}>🗑️</button>
          </div>
        ))}
        <button className="add-btn" onClick={() => addTableRow('teachers', { name: '', position: '', subject: '' })}>+ Add Teacher</button>
      </div>
    </div>
  );
}

export default TeachersEditor;